import PptxGenJS from 'pptxgenjs';
import { CuriousLogo } from 'assets';

export const removeDuplicates = (arr) => {
  return [...new Set(arr)];
};
export const mergeStackedData = (data) => {
  const mergedData = {};

  data.forEach((item) => {
    if (!mergedData[item.name]) {
      mergedData[item.name] = { name: item.name, data: [], count: [] };
    }
    mergedData[item.name].data.push(...item.data);
    mergedData[item.name].count.push(...item.count);
  });

  return Object.values(mergedData);
};
export const downloadPPTmulti = async (surveyData, fileName, isCrossTab, isMulti) => {
  const baseColors = [
    '7438f2',
    '009150',
    'FF7F0E',
    '1F77B4',
    'D62728',
    '9467BD',
    '8C564B',
    'E377C2',
    '7F7F7F',
    'BCBD22',
    '17BECF',
    'F5A623',
    '4E79A7',
    '6fcf61',
    'E15759',
    '76B7B2',
    '136213'
  ];

  let pptx = new PptxGenJS();

  const processSlide = async (survey) => {
    let chartOptions = {
      x: 1,
      y: 1,
      w: 8,
      h: 4,
      chartColors: survey.qText.length > 1 ? baseColors : ['7438f2'],
      dataLabelFormatCode: '0%',
      dataLabelColor: '000000',
      dataLabelFontFace: 'Arial',
      dataLabelFontSize: 5,
      showValue: true,
      catAxisLabelFontSize: 6,
      showAxisLabels: false,
      valAxisHidden: true,
      showPercent: true
    };

    let slide = pptx.addSlide();
    slide.addImage({
      path: CuriousLogo,
      x: 8.2,
      y: 0.1,
      h: 0.5354331,
      w: 1.582677
    });
    slide.addText(`[${survey.surveyQId}] ${survey.title}`, {
      x: 0.5,
      y: 0.2,
      h: 0.6,
      align: 'top',
      fontSize: 14,
      bold: true
    });
    slide.addText(`Base: ${survey.base}`, { x: 0.5, y: 5.35, fontSize: 6, bold: true });

    let chartData = [];

    if (survey.qText.length > 1) {
      chartOptions = { ...chartOptions, showLegend: true, legendFontSize: 6, legendPos: 't' };
      if (isCrossTab) {
        chartOptions = { ...chartOptions, barGrouping: 'stacked' };
      }
      // multi
      if (isMulti) {
        let stackArr = [];

        survey.options.forEach((option) => {
          if (option.stack != '') {
            stackArr.push(option.stack);
          }
        });
        const uniqStack = removeDuplicates(stackArr);
        let categories = [];
        survey.qText.map((item) => {
          uniqStack.map((stack) => {
            categories.push(`${item} (${stack})`);
          });
        });

        const seriesData = mergeStackedData(survey.options);

        chartData = seriesData.map((option) => ({
          name: option.name,
          labels: categories,
          values: option.data.map((d) => d / 100)
        }));
      } else {
        chartData = survey.options.map((option) => ({
          name: option.name,
          labels: survey.qText,
          values: option.data.map((d) => d / 100)
        }));
      }
      // end multi

      // chartData = survey.options.map((option) => ({
      //   name: option.name,
      //   labels: survey.qText,
      //   values: option.data.map((d) => d / 100)
      // }));
    } else {
      const data = survey.options.map((option) => ({
        name: option.name,
        value: option.data[0]
      }));

      chartData = [
        {
          name: 'Responses',
          labels: data.map((d) => d.name),
          values: data.map((d) => d.value / 100)
        }
      ];
    }

    if (survey.options.length > 0) {
      slide.addChart(isCrossTab ? pptx.ChartType.bar : pptx.ChartType.bar, chartData, chartOptions);
    } else {
      slide.addText(`No records to display the chart`, {
        x: 1,
        y: 1.2,
        w: 8,
        h: 2,
        fontSize: 10,
        bold: true,
        align: 'center'
      });
    }

    await new Promise((resolve) => setTimeout(resolve, 10));
  };

  await Promise.all(surveyData.map(processSlide));

  await pptx.writeFile({ fileName: `${fileName}.pptx`, compression: true, verbose: true });
};
